import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgDocs = function SvgDocs(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_246_47166)",
        fillOpacity: 0.16,
        d: "M25.615 74q-1.92 0-3.268-1.347T21 69.385v-50.77q0-1.92 1.347-3.268T25.615 14h25.95q1 0 1.83.385a6 6 0 0 1 1.496.987l11.404 11.404q.602.666.987 1.496a4.3 4.3 0 0 1 .385 1.83v39.283q0 1.92-1.347 3.268T63.05 74z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_246_47166)",
        d: "M29.93 57.949h20.807q.545 0 .914-.374.368-.374.368-.926 0-.553-.368-.909a1.26 1.26 0 0 0-.914-.355H29.93q-.546 0-.914.373-.369.374-.369.927 0 .551.369.908.368.356.914.356m0-13.718h20.807q.545 0 .914-.374.368-.374.368-.926 0-.553-.368-.909a1.26 1.26 0 0 0-.914-.355H29.93q-.546 0-.914.373-.369.374-.369.927 0 .552.369.908.368.356.914.356M21.615 70q-1.92 0-3.268-1.347T17 65.385v-50.77q0-1.92 1.347-3.268T21.615 10h25.95q1 0 1.83.385a6 6 0 0 1 1.496.987l11.404 11.404q.602.666.987 1.496a4.3 4.3 0 0 1 .385 1.83v39.283q0 1.92-1.347 3.268T59.05 70zm26.558-46.91V12.564H21.615q-.768 0-1.41.641-.64.642-.64 1.41v50.77q0 .769.64 1.41.642.64 1.41.64h37.436q.77 0 1.41-.64.642-.641.642-1.41V25.372H50.454q-.907 0-1.594-.687t-.687-1.595"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_246_47166",
        x1: 21.487,
        x2: 67.017,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_246_47166",
        x1: 17.487,
        x2: 63.017,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgDocs as ReactComponent };
//# sourceMappingURL=Docs.svg.es.js.map
